import CrmAccountFields from "./fields";
import FieldsCollection from "../../fields3/collection/base/fields-collection";
import FormManager from "../../gd-form/common/form-manager";
import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature, FEATURE_CRM} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

const TITLE_FIELD_MIN_WIDTH = 300

const debug = false

export default class CrmAccountModule extends ModuleProto{

    constructor(moduleConfig: any) {
        super(ModuleType.CRM_ACCOUNT, moduleConfig);

        this.name                       = "CRM Account"
        this.description                = "The GoodDay CRM Account module enables essential CRM capabilities and provides robust customization options for account fields, allowing you to configure your CRM to perfectly suit your business operations and enhance your account management strategy. \n\n This module requires the GoodDay CRM module to be enabled first."
        this.typeLabel                  = "CRM"
        this.svgIcon                    = "isvg-crm-account"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION

        this.settingsUrl                = "settings/crm-account"
        this.parentSection              = SettingsParentSection.CRM

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.feature                    = Feature.CRM
        this.validateFeature()
    }

    get enabled() {
        return super.enabled && gd.modules.crm.enabled
    }

    static getFieldsCollection() {
        const config = CrmAccountFields.getFieldsConfig();
        return new FieldsCollection(config);
    }

    static getSystemFieldsCollection() {
        const config = CrmAccountFields.getSystemFieldsConfig();
        return new FieldsCollection(config);
    }

    static getCustomFieldsCollection() {
        const config = CrmAccountFields.getCustomFieldsConfig();
        return new FieldsCollection(config);
    }

    static saveCustomFields(fieldsCollection: FieldsCollection) {
        return CrmAccountFields.saveCustomFields(fieldsCollection);
    }

    static getGlistConfig() {
        const titleField = 'name';
        // const company = gd.session.companies.get(gd.companyId);

        const glistConfig = _.get(gd.company.settings.modules, 'crmAccount.glist');

        let columns = _.get(glistConfig,'columns',null) || [
            {fieldId: 'name'},
            {fieldId: 'website'},
            {fieldId: 'phone'},
            {fieldId: 'email'},
            {fieldId: 'accountOwnerUserId'},
            {fieldId: 'crmContactsTotal'},
        ];

        const titleFieldColumn = _.find(columns, column => column.fieldId === titleField)
        if(!titleFieldColumn) {
            columns.unshift({fieldId: titleField, minWidth: TITLE_FIELD_MIN_WIDTH})
        } else {
            titleFieldColumn.minWidth = TITLE_FIELD_MIN_WIDTH
        }

        const groupByValue = glistConfig && glistConfig.groupBy ? glistConfig.groupBy : {
            fieldId     : null
        }

        return {columns, groupByValue, titleField}
    }

    static saveGlistConfig(columns: any, groupByValue: any) {
        const company = gd.session.companies.get(gd.companyId);
        company.settings.modules.crmAccount.glist.columns = columns;
        company.settings.modules.crmAccount.glist.groupBy = groupByValue;
        company.settings.save()
    }

    static getFormConfig(options: any) {
        const fields = CrmAccountModule.getFieldsCollection();

        const initFormData: any = {};
        const formStructureFields: any = {};

        const hideFields = ['accountOwnerUserId'];

        _.map(fields.all(), (field: any)=>{
            initFormData[field.fieldId] = field.formInitValue;
            formStructureFields[field.fieldId] = {
                type:       field.formType,
                isRequired: field.isRequired,
                label:      field.label,
                validator:  field.validator.bind(field),
            }
        })

        const formStructure = {
            fields: formStructureFields,
            onSubmit: options.onSubmit,
            isFormChanged: true,
        };

        // hide some specified fields and not required customFields
        const allFields = fields.all().slice();
        _.map(allFields, field=>{
            if (hideFields.includes(field.fieldId) || (field.isCustom && !field.isRequired)) {
                fields.removeById(field.fieldId);
            }
        })

        return {
            formManager: new FormManager(formStructure, initFormData),
            fields: fields
        };
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)

        const result = super.toJson();
        // const result = {}

        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
